module.exports = __webpack_public_path__ + "img/vision-icon.16f15c18.svg";